import * as types from "../types/walletIssue.types";
import {  
  getWalletIssueList, 
} from '../../services/walletIssue.service';
import { validationErrors } from "../../utils/Helpers";

export const getWalletIssueListAction = (data) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await getWalletIssueList(getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        dispatch({
          type: types.SET_WALLET_ISSUE_DATA,
          payload: res.data.data,
        });
        if(res.data.pagination){
          dispatch({
            type: types.SET_WALLET_ISSUE_PAGINATION,
            payload: res.data.pagination,
          });
        }
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};